

const fileAcceptTypes = {
    // Documents
    "application/pdf": [".pdf"],
    "application/msword": [".doc", ".docx"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/vnd.ms-excel": [".xls", ".xlsx"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-powerpoint": [".ppt", ".pptx"],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
    "text/plain": [".txt"],
    "application/rtf": [".rtf"],
    "application/json": [".json"],
    "application/xml": [".xml"],
    "application/csv": [".csv"],
  
    // Images
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/webp": [".webp"],
    "image/svg+xml": [".svg"],
    "image/bmp": [".bmp"],
    "image/tiff": [".tif", ".tiff"],
  
    // Audio
    "audio/mpeg": [".mp3"],
    "audio/wav": [".wav"],
    "audio/ogg": [".ogg"],
    "audio/aac": [".aac"],
  
    // Video
    "video/mp4": [".mp4"],
    "video/x-msvideo": [".avi"],
    "video/quicktime": [".mov"],
    "video/x-matroska": [".mkv"],
    "video/webm": [".webm"],
  
    // Archives
    "application/zip": [".zip"],
    "application/x-rar-compressed": [".rar"],
    "application/x-7z-compressed": [".7z"],
    "application/gzip": [".gz"],
    "application/x-tar": [".tar"],
  
    // Others
    "application/x-sh": [".sh"],
    "application/x-python-code": [".py"],
    "application/javascript": [".js"],
    "application/x-httpd-php": [".php"],
    "text/html": [".html", ".htm"],
    "text/css": [".css"]
  };
  
  export default fileAcceptTypes;
  